import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import {
  classduration,
  classSection,
  classSylabus,
  language,
  period,
  routinename,
  subjectGroup,
  teacher,
  Time,
  Timeto,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import TooltipOption from "../../../core/common/tooltipOption";
import UserService from "../../network/services/UserService";
import { getUser } from "../../network/auth/Auth";
import moment from "moment";
import { Modal, Toast } from "react-bootstrap";

const ClassTimetable = () => {
  const routes = all_routes;

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };


  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const [wednessdayContents, setwednessdayContents] = useState<number[]>([0]);
  const [thursdayContents, setthursdayContents] = useState<number[]>([0]);
  const [fridayContents, setfridayContents] = useState<number[]>([0]);


  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };



  const addwednessdayContent = () => {
    setwednessdayContents([...wednessdayContents, wednessdayContents.length]);
  };
  const addthursdayContents = () => {
    setthursdayContents([...thursdayContents, thursdayContents.length]);
  };
  const addfridayContents = () => {
    setfridayContents([...fridayContents, fridayContents.length]);
  };

  const removewednessdayContent = (index: any) => {
    setwednessdayContents(wednessdayContents.filter((_, i) => i !== index));
  };
  const removethursdayContents = (index: any) => {
    setthursdayContents(thursdayContents.filter((_, i) => i !== index));
  };
  const removefridayContents = (index: any) => {
    setfridayContents(fridayContents.filter((_, i) => i !== index));
  };


  interface TimetableData {
    id: any;
    name: any;
    days: any;
    sessions: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [timetables, setTimetables] = useState<TimetableData[]>([]);


  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);


  const fetchData = async (company_id: any, course_id: any) => {
    UserService.getTimetableSearch(company_id, course_id, (response: any) => {
      if (response?.data && response?.success) {
        console.log(response.data);
        setTimetables(response.data)


      }
    });
  };

  const formatTime = (datetime: any) => {
    const date = new Date(datetime);
    const hours = date.getHours().toString().padStart(2, '0'); // Format pour HH
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Format pour MM
    const seconds = date.getSeconds().toString().padStart(2, '0'); // Format pour SS

    return `${hours}:${minutes}:${seconds}`;
  };

  const getTimeRange = (name: any) => {
    const timeRangePattern = /\d{1,2}:\d{2}[AP]M-\d{1,2}:\d{2}[AP]M/;
    const match = name.match(timeRangePattern);

    return match ? match[0] : null; // Retourne la plage horaire ou null si non trouvée
  };


  interface CourseData {
    id: any;
    name: any;
    code: any;
    parent_id: any;
    evaluation_type: any;
    subject_ids: any;
    department_id: any;
    active: any;
    fees_term_id: any;
    operating_branch_id: any;
    company_id: any

  }
  interface OptionType {
    label: any;
    value: any;
  }

  const [batches, setBatches] = useState<OptionType[]>([]);




  const fetchDataBatch = async (company_id: any) => {
    UserService.getBatchesByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        const batchOptions: OptionType[] = response.data.map((batch: any) => ({
          value: batch.id,
          label: batch.name,
        }));
        setBatches(batchOptions);



      }
    });
  };

  useEffect(() => {
    fetchDataBatch(getUser()?.company_ids[0]?.id);
  }, []);

  const [courses, setCourses] = useState<OptionType[]>([]);

  const fetchDataCourse = async (company_id: any) => {
    UserService.getCourseByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        const courseAsOptions: OptionType[] = response.data.map((couse: any) => ({
          value: couse.id,
          label: couse.name,
        }));
        setCourses(courseAsOptions);
      }
    });
  };

  useEffect(() => {
    fetchDataCourse(getUser()?.company_ids[0]?.id);
  }, []);


  const [branches, setBranches] = useState<OptionType[]>([]);


  const fetchBranch = () => {
    const branches = getUser()?.company_ids[0]?.branches;
    const branchesAsOptions: OptionType[] = branches.map((item: any) => ({
      value: item.id,
      label: item.name,
    }));
    setBranches(branchesAsOptions);
  }
  useEffect(() => {
    fetchBranch();
  }, []);


  const [subjects, setSubjects] = useState<OptionType[]>([]);

  const fetchDataSubjects = async (company_id: any) => {
    UserService.getSubjectsByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        const subjectsAsOptions: OptionType[] = response.data.map((subject: any) => ({
          value: subject.id,

          label: subject.name,
        }));
        // Appel de la fonction setAllSubjects
        setSubjects(subjectsAsOptions);
      }
    });
  };

  useEffect(() => {
    fetchDataSubjects(getUser()?.company_ids[0]?.id);
  }, []);



  const [teachers, setTeachers] = useState<OptionType[]>([]);



  const fetchDataTeacher = async (company_id: any) => {
    UserService.getTeachersByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        const teachersAsOptions: OptionType[] = response.data.map((item: any) => ({
          value: item.id,

          label: item.first_name + " " + item.last_name,
        }));
        setTeachers(teachersAsOptions);

      }
    });
  };

  useEffect(() => {
    fetchDataTeacher(getUser()?.company_ids[0]?.id);
  }, []);

  const location = useLocation()

  console.log(location?.state?.course)
  useEffect(() => {
    if (location?.state) {
      fetchData(getUser()?.company_ids[0]?.id, location?.state?.course?.id);

    }
  }, []);


  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };


  interface FormDataType {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData, setFormData] = useState<FormDataType>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData((prevFormData) => ({
        ...prevFormData,
        newContents: prevFormData.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const addNewContent = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      newContents: [
        ...prevFormData.newContents,
        {
          subject_id: parseInt(formData.subject_id, 10),
          faculty_id: parseInt(formData.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "0"
        },
      ],
    }));
  };
  const removeContent = (index: number) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      newContents: prevFormData.newContents.filter((_, i) => i !== index),
    }));
  };







  interface FormDataType2 {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData2, setFormData2] = useState<FormDataType2>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange2 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData2((prevFormData2) => ({
        ...prevFormData2,
        newContents: prevFormData2.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData2({
        ...formData2,
        [name]: value
      });
    }
  };

  const addNewContent2 = () => {
    setFormData2((prevFormData2) => ({
      ...prevFormData2,
      newContents: [
        ...prevFormData2.newContents,
        {
          subject_id: parseInt(formData2.subject_id, 10),
          faculty_id: parseInt(formData2.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "1"
        },
      ],
    }));
  };
  const removeContent2 = (index: number) => {
    setFormData2((prevFormData2) => ({
      ...prevFormData2,
      newContents: prevFormData2.newContents.filter((_, i) => i !== index),
    }));
  };



  interface FormDataType3 {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData3, setFormData3] = useState<FormDataType3>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange3 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData3((prevFormData3) => ({
        ...prevFormData3,
        newContents: prevFormData3.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData3({
        ...formData3,
        [name]: value
      });
    }
  };

  const addNewContent3 = () => {
    setFormData3((prevFormData3) => ({
      ...prevFormData3,
      newContents: [
        ...prevFormData3.newContents,
        {
          subject_id: parseInt(formData3.subject_id, 10),
          faculty_id: parseInt(formData3.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "2"
        },
      ],
    }));
  };
  const removeContent3 = (index: number) => {
    setFormData3((prevFormData3) => ({
      ...prevFormData3,
      newContents: prevFormData3.newContents.filter((_, i) => i !== index),
    }));
  };




  interface FormDataType4 {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData4, setFormData4] = useState<FormDataType4>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange4 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData4((prevFormData4) => ({
        ...prevFormData4,
        newContents: prevFormData4.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData4({
        ...formData4,
        [name]: value
      });
    }
  };

  const addNewContent4 = () => {
    setFormData4((prevFormData4) => ({
      ...prevFormData4,
      newContents: [
        ...prevFormData4.newContents,
        {
          subject_id: parseInt(formData4.subject_id, 10),
          faculty_id: parseInt(formData4.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "3"
        },
      ],
    }));
  };
  const removeContent4 = (index: number) => {
    setFormData4((prevFormData4) => ({
      ...prevFormData4,
      newContents: prevFormData4.newContents.filter((_, i) => i !== index),
    }));
  };


  interface FormDataType5 {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData5, setFormData5] = useState<FormDataType5>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange5 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData5((prevFormData5) => ({
        ...prevFormData5,
        newContents: prevFormData5.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData5({
        ...formData5,
        [name]: value
      });
    }
  };

  const addNewContent5 = () => {
    setFormData5((prevFormData5) => ({
      ...prevFormData5,
      newContents: [
        ...prevFormData5.newContents,
        {
          subject_id: parseInt(formData5.subject_id, 10),
          faculty_id: parseInt(formData5.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "4"
        },
      ],
    }));
  };
  const removeContent5 = (index: number) => {
    setFormData5((prevFormData5) => ({
      ...prevFormData5,
      newContents: prevFormData5.newContents.filter((_, i) => i !== index),
    }));
  };


  interface FormDataType6 {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData6, setFormData6] = useState<FormDataType6>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange6 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData6((prevFormData6) => ({
        ...prevFormData6,
        newContents: prevFormData6.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData6({
        ...formData6,
        [name]: value
      });
    }
  };

  const addNewContent6 = () => {
    setFormData6((prevFormData6) => ({
      ...prevFormData6,
      newContents: [
        ...prevFormData6.newContents,
        {
          subject_id: parseInt(formData6.subject_id, 10),
          faculty_id: parseInt(formData6.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "5"
        },
      ],
    }));
  };
  const removeContent6 = (index: number) => {
    setFormData6((prevFormData6) => ({
      ...prevFormData6,
      newContents: prevFormData6.newContents.filter((_, i) => i !== index),
    }));
  };



  interface FormDataType7 {
    subject_id: string;
    faculty_id: string;
    course_id: string;
    batch_id: string;
    start_date: string;
    end_date: string;
    session_start_time: string;
    session_end_time: string;
    company_id: string;
    operating_branch_id: string;
    newContents: Array<{
      subject_id: number;
      faculty_id: number;
      session_start_time: string;
      session_end_time: string;
      day: string;
    }>;

  }


  // État initial avec newContents défini
  const [formData7, setFormData7] = useState<FormDataType7>({
    subject_id: '',
    faculty_id: '',
    course_id: '',
    batch_id: '',
    start_date: '',
    end_date: '',
    session_start_time: '',
    session_end_time: '',
    company_id: '',
    operating_branch_id: '',
    newContents: [], // Initialize as an empty array
  });


  const handleInputChange7 = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index?: number) => {
    const { name, value } = e.target;
    if (index !== undefined) {
      // Handle change for newContents
      const newValue =
        name === 'subject_id' || name === 'faculty_id'
          ? parseInt(value, 10) : value;
      setFormData7((prevFormData7) => ({
        ...prevFormData7,
        newContents: prevFormData7.newContents.map((content, i) =>
          i === index
            ? { ...content, [name]: newValue }
            : content
        ),
      }));
    } else {
      // Handle change for other fields
      setFormData7({
        ...formData7,
        [name]: value
      });
    }
  };

  const addNewContent7 = () => {
    setFormData7((prevFormData7) => ({
      ...prevFormData7,
      newContents: [
        ...prevFormData7.newContents,
        {
          subject_id: parseInt(formData7.subject_id, 10),
          faculty_id: parseInt(formData7.faculty_id, 10),
          session_start_time: '',
          session_end_time: '',
          day: "6"
        },
      ],
    }));
  };
  const removeContent7 = (index: number) => {
    setFormData7((prevFormData7) => ({
      ...prevFormData7,
      newContents: prevFormData7.newContents.filter((_, i) => i !== index),
    }));
  };



  interface TimeTableLine {
    subject_id: number;
    faculty_id: number;
    session_start_time: string;
    session_end_time: string;
    day: string;
  }

  // Fonction pour filtrer les objets en vérifiant leurs propriétés
  const filterValidContents = (contents: TimeTableLine[]) => {
    return contents.filter((item: TimeTableLine) =>
      item.subject_id != null &&
      item.faculty_id != null &&
      item.session_start_time !== "" &&
      item.session_end_time !== "" &&
      item.day !== ""
    );
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 2500);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 2500);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);


  const handleSubmit = () => {
    setIsLoading(true)
    // Filtrer les données avant de les utiliser
    const filteredFormData = filterValidContents(formData.newContents);
    const filteredFormData2 = filterValidContents(formData2.newContents);
    const filteredFormData3 = filterValidContents(formData3.newContents);
    const filteredFormData4 = filterValidContents(formData4.newContents);
    const filteredFormData5 = filterValidContents(formData5.newContents);

    // Créer l'objet request_data avec les données filtrées
    const request_data = {
      "course_id": parseInt(formData.course_id, 10),
      "batch_id": parseInt(formData.batch_id, 10),
      "start_date": formData.start_date,
      "end_date": formData.end_date,
      "company_id": parseInt(getUser()?.company_ids[0]?.id),
      "operating_branch_id": parseInt(formData.operating_branch_id, 10),
      "time_table_lines": [
        ...filteredFormData,
        ...filteredFormData2,
        ...filteredFormData3,
        ...filteredFormData4,
        ...filteredFormData5
      ],
    };
    // Vérifiez s'il y a des données valides à envoyer
    if (request_data.time_table_lines.length > 0) {
      console.log(request_data);
      UserService.addTimetable(request_data, (response: any) => {
        if (response.success) {
          setIsLoading(false)

          setFormData({
            subject_id: '',
            faculty_id: '',
            course_id: '',
            batch_id: '',
            start_date: '',
            end_date: '',
            session_start_time: '',
            session_end_time: '',
            company_id: '',
            operating_branch_id: '',
            newContents: [], // Initialize as an empty array
          });
          handleClose2()
        } else {
          setFormData({
            subject_id: '',
            faculty_id: '',
            course_id: '',
            batch_id: '',
            start_date: '',
            end_date: '',
            session_start_time: '',
            session_end_time: '',
            company_id: '',
            operating_branch_id: '',
            newContents: [], // Initialize as an empty array
          });
          setErrorMessage('An error has occurred, please try again.')
          setShowDangerToast(true)
          setIsLoading(false)
        }
      });
    } else {
      setErrorMessage('An error has occurred, please try again.')
      setShowDangerToast(true)
      setIsLoading(false)
      console.log("No valid data to send");
    }

    /*   UserService.addTimetable(request_data, (response: any) => {
        if (response.success) {
          console.log('ici')
  
          setFormData({
            subject_id: '',
            faculty_id: '',
            course_id: '',
            batch_id: '',
            start_date: '',
            end_date: '',
            session_start_time: '',
            session_end_time: '',
            company_id: '',
            operating_branch_id: '',
            newContents: [], // Initialize as an empty array
          });
          handleClose2()
        } else {
          setFormData({
            subject_id: '',
            faculty_id: '',
            course_id: '',
            batch_id: '',
            start_date: '',
            end_date: '',
            session_start_time: '',
            session_end_time: '',
            company_id: '',
            operating_branch_id: '',
            newContents: [], // Initialize as an empty array
          });
  
        }
      }); */
  };



  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Time Table</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Academic</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Time Table
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={handleShow}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Time Table
                </Link>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Time Table</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                    aria-expanded="false"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>

                              <CommonSelect
                                className="select"
                                options={classSylabus}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={classSection}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body pb-0">
              <div className="d-flex flex-nowrap overflow-auto">

                {timetables && timetables?.map((item: any, index: any) => (
                  <div className="d-flex flex-column me-4 flex-fill" key={index}>
                    <div className="mb-3">
                      <h6>{item?.day}</h6>
                    </div>

                    {item?.sessions && item?.sessions.map((item: any, index: any) => (
                      <div className="bg-transparent-light rounded p-3 mb-4" key={index}>
                        <p className="d-flex align-items-center text-nowrap mb-1">
                          <i className="ti ti-calendar me-1" />
                          {item?.start_datetime ? moment(item?.start_datetime).format('ddd DD MMM YYYY') : ""}
                        </p>
                        <p className="d-flex align-items-center text-nowrap mb-1">
                          <i className="ti ti-clock me-1" />
                          {item?.name ? getTimeRange(item?.name) : ""}
                        </p>

                        <p className="text-dark">Subject : {item?.subject_id.name}</p>
                        <div className="bg-white rounded p-1 mt-3">
                          <Link
                            to={routes.teacherDetails}
                            className="text-muted d-flex align-items-center"
                          >
                            <span className="avatar avatar-sm me-2">
                              <img
                                src={`data:image/png;base64,${item?.faculty_id?.partner_id?.avatar}`}
                                alt="Img"
                              />
                            </span>
                            {item?.faculty_id?.partner_id?.name}
                          </Link>
                        </div>
                      </div>
                    ))}

                  </div>))}



              </div>
            </div>
            <div className="card-footer border-0 pb-0">
              <div className="row">
                <div className="col-lg-4 col-xxl-4 col-xl-4 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="bg-primary badge badge-sm mb-2">
                        Morning Break
                      </span>
                      <p className="text-dark">
                        <i className="ti ti-clock me-1" />
                        10:30 to 10 :45 AM
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-xxl-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="bg-warning badge badge-sm mb-2">
                        Lunch
                      </span>
                      <p className="text-dark">
                        <i className="ti ti-clock me-1" />
                        10:30 to 10 :45 AM
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-xxl-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <span className="bg-info badge badge-sm mb-2">
                        Evening Break
                      </span>
                      <p className="text-dark">
                        <i className="ti ti-clock me-1" />
                        03:30 PM to 03:45 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <>



        <Modal show={showModal} onHide={handleClose} size={"xl"} >
          <Modal.Header >
            <Modal.Title>Add Timetable</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form >
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">Course</label>
                      <select

                        className="select react-select form-control"
                        name="course_id"

                        onChange={handleInputChange}
                      >
                        <option >Select courses</option>
                        {courses && courses?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">Batch</label>
                      <select

                        className="select react-select form-control"
                        name="batch_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Batch</option>
                        {batches && batches?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label className="form-label">Branches </label>
                      <select

                        className="select react-select form-control"
                        name="operating_branch_id"
                        onChange={handleInputChange}
                      >
                        <option >Select Branches</option>
                        {branches && branches?.map((item: any) => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}

                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Start data</label>
                      <input type="date" className="form-control" name="start_date"
                        value={formData.start_date}
                        onChange={handleInputChange} />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">End date</label>
                      <input type="date" className="form-control" name="end_date"
                        value={formData.end_date}
                        onChange={handleInputChange} />
                    </div>
                  </div>
                </div>
                <div className="add-more-timetable">
                  <ul
                    className="tab-links nav nav-pills"
                    id="pills-tab2"
                    role="tablist"
                  >
                    <li
                      className="nav-link active"
                      id="pills-monday-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-monday"
                      role="tab"
                      aria-controls="pills-monday"
                      aria-selected="true"
                    >
                      <Link to="#">Monday</Link>
                    </li>
                    <li
                      className="nav-link"
                      id="pills-tuesday-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-tuesday"
                      role="tab"
                      aria-controls="pills-tuesday"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      <Link to="#">Tuesday</Link>
                    </li>
                    <li
                      className="nav-link"
                      id="pills-wednesday-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-wednesday"
                      role="tab"
                      aria-controls="pills-wednesday"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      <Link to="#">Wednesday</Link>
                    </li>
                    <li
                      className="nav-link"
                      id="pills-thursday-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-thursday"
                      role="tab"
                      aria-controls="pills-thursday"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      <Link to="#">Thursday</Link>
                    </li>
                    <li
                      className="nav-link"
                      id="pills-friday-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-friday"
                      role="tab"
                      aria-controls="pills-friday"
                      aria-selected="false"
                      tabIndex={-1}
                    >
                      <Link to="#">Friday</Link>
                    </li>
                  </ul>
                  <div className="tab-content pt-0 dashboard-tab">
                    <div
                      className="tab-pane fade show active"
                      id="pills-monday"
                      role="tabpanel"
                      aria-labelledby="pills-monday-tab"
                    >
                      {formData.newContents.map((content: any, index: any) => (
                        <div className="add-timetable-row" key={index}>
                          <div className="row timetable-count">
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <select
                                  className="select react-select form-control"
                                  name="subject_id"
                                  value={content.subject} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange(e, index)}
                                >
                                  <option>Select Subject</option>
                                  {subjects?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Teacher</label>
                                <select
                                  className="select react-select form-control"
                                  name="faculty_id"
                                  value={content.teacher} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange(e, index)}
                                >
                                  <option>Select Teacher</option>
                                  {teachers?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Start Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="session_start_time"
                                  value={content.timeFrom} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange(e, index)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="d-flex align-items-end">
                                <div className="mb-3 flex-fill">
                                  <label className="form-label">End Time</label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="session_end_time"
                                    value={content.timeTo} // Récupération de la valeur depuis newContents
                                    onChange={(e) => handleInputChange(e, index)}
                                  />
                                </div>
                                {formData.newContents.length > 1 && (
                                  <div className="mb-3 ms-2">
                                    <Link to="#" className="delete-time-table" onClick={() => removeContent(index)}>
                                      <i className="ti ti-trash" />
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div>
                        <Link
                          to="#"
                          className="btn btn-primary add-new-timetable"
                          onClick={addNewContent}
                        >
                          <i className="ti ti-square-rounded-plus-filled me-2" />
                          Add New
                        </Link>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-tuesday"
                      role="tabpanel"
                      aria-labelledby="pills-tuesday-tab"
                    >
                      {formData2.newContents.map((content: any, index: any) => (
                        <div className="add-timetable-row" key={index}>
                          <div className="row timetable-count">
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <select
                                  className="select react-select form-control"
                                  name="subject_id"
                                  value={content.subject} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange2(e, index)}
                                >
                                  <option>Select Subject</option>
                                  {subjects?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Teacher</label>
                                <select
                                  className="select react-select form-control"
                                  name="faculty_id"
                                  value={content.teacher} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange2(e, index)}
                                >
                                  <option>Select Teacher</option>
                                  {teachers?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Start Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="session_start_time"
                                  value={content.timeFrom} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange2(e, index)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="d-flex align-items-end">
                                <div className="mb-3 flex-fill">
                                  <label className="form-label">End Time</label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="session_end_time"
                                    value={content.timeTo} // Récupération de la valeur depuis newContents
                                    onChange={(e) => handleInputChange2(e, index)}
                                  />
                                </div>
                                {formData2.newContents.length > 1 && (
                                  <div className="mb-3 ms-2">
                                    <Link to="#" className="delete-time-table" onClick={() => removeContent2(index)}>
                                      <i className="ti ti-trash" />
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div>
                        <Link
                          to="#" onClick={addNewContent2}
                          className="btn btn-primary add-new-timetable"
                        >
                          <i className="ti ti-square-rounded-plus-filled me-2" />
                          Add New
                        </Link>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-wednesday"
                      role="tabpanel"
                      aria-labelledby="pills-wednesday-tab"
                    >
                      {formData3.newContents.map((content: any, index: any) => (
                        <div className="add-timetable-row" key={index}>
                          <div className="row timetable-count">
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <select
                                  className="select react-select form-control"
                                  name="subject_id"
                                  value={content.subject} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange3(e, index)}
                                >
                                  <option>Select Subject</option>
                                  {subjects?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Teacher</label>
                                <select
                                  className="select react-select form-control"
                                  name="faculty_id"
                                  value={content.teacher} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange3(e, index)}
                                >
                                  <option>Select Teacher</option>
                                  {teachers?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Start Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="session_start_time"
                                  value={content.timeFrom} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange3(e, index)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="d-flex align-items-end">
                                <div className="mb-3 flex-fill">
                                  <label className="form-label">End Time</label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="session_end_time"
                                    value={content.timeTo} // Récupération de la valeur depuis newContents
                                    onChange={(e) => handleInputChange3(e, index)}
                                  />
                                </div>
                                {formData3.newContents.length > 1 && (
                                  <div className="mb-3 ms-2">
                                    <Link to="#" className="delete-time-table" onClick={() => removeContent3(index)}>
                                      <i className="ti ti-trash" />
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div>

                        <Link
                          to="#"
                          className="btn btn-primary add-new-timetable" onClick={addNewContent3}
                        >
                          <i className="ti ti-square-rounded-plus-filled me-2" />
                          Add New
                        </Link>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-thursday"
                      role="tabpanel"
                      aria-labelledby="pills-thursday-tab"
                    >
                      {formData4.newContents.map((content: any, index: any) => (
                        <div className="add-timetable-row" key={index}>
                          <div className="row timetable-count">
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <select
                                  className="select react-select form-control"
                                  name="subject_id"
                                  value={content.subject} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange4(e, index)}
                                >
                                  <option>Select Subject</option>
                                  {subjects?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Teacher</label>
                                <select
                                  className="select react-select form-control"
                                  name="faculty_id"
                                  value={content.teacher} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange4(e, index)}
                                >
                                  <option>Select Teacher</option>
                                  {teachers?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Start Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="session_start_time"
                                  value={content.timeFrom} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange4(e, index)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="d-flex align-items-end">
                                <div className="mb-3 flex-fill">
                                  <label className="form-label">End Time</label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="session_end_time"
                                    value={content.timeTo} // Récupération de la valeur depuis newContents
                                    onChange={(e) => handleInputChange4(e, index)}
                                  />
                                </div>
                                {formData4.newContents.length > 1 && (
                                  <div className="mb-3 ms-2">
                                    <Link to="#" className="delete-time-table" onClick={() => removeContent4(index)}>
                                      <i className="ti ti-trash" />
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div>
                        <Link
                          to="#"
                          className="btn btn-primary add-new-timetable" onClick={addNewContent4}
                        >
                          <i className="ti ti-square-rounded-plus-filled me-2" />
                          Add New
                        </Link>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="pills-friday"
                      role="tabpanel"
                      aria-labelledby="pills-friday-tab"
                    >
                      {formData5.newContents.map((content: any, index: any) => (
                        <div className="add-timetable-row" key={index}>
                          <div className="row timetable-count">
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <select
                                  className="select react-select form-control"
                                  name="subject_id"
                                  value={content.subject} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange5(e, index)}
                                >
                                  <option>Select Subject</option>
                                  {subjects?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Teacher</label>
                                <select
                                  className="select react-select form-control"
                                  name="faculty_id"
                                  value={content.teacher} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange5(e, index)}
                                >
                                  <option>Select Teacher</option>
                                  {teachers?.map((item: any) => (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="mb-3">
                                <label className="form-label">Start Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="session_start_time"
                                  value={content.timeFrom} // Récupération de la valeur depuis newContents
                                  onChange={(e) => handleInputChange5(e, index)}
                                />
                              </div>
                            </div>
                            <div className="col-lg-3">
                              <div className="d-flex align-items-end">
                                <div className="mb-3 flex-fill">
                                  <label className="form-label">End Time</label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="session_end_time"
                                    value={content.timeTo} // Récupération de la valeur depuis newContents
                                    onChange={(e) => handleInputChange5(e, index)}
                                  />
                                </div>
                                {formData5.newContents.length > 1 && (
                                  <div className="mb-3 ms-2">
                                    <Link to="#" className="delete-time-table" onClick={() => removeContent5(index)}>
                                      <i className="ti ti-trash" />
                                    </Link>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div>
                        <Link
                          to="#"
                          className="btn btn-primary add-new-timetable" onClick={addNewContent5}
                        >
                          <i className="ti ti-square-rounded-plus-filled me-2" />
                          Add New
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Add Time Table
                </Link>
              </div>
            </form>
          </Modal.Body>

        </Modal>




        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>
      </>
    </div>
  );
};

export default ClassTimetable;
